export const nuxtBaseUrl = '/bp'
export const experienceBaseRoute = 'application';
export const singleConfigBaseRoute = 'app';
export const requirementsBaseRoute = 'requirements';

export const eventOptions = {
  moduleLoaded: 'moduleLoaded',
  moduleCompleted: 'moduleCompleted',
  moduleSkipped: 'moduleSkipped',
  documentUploaded: 'documentUploaded',
  documentDeleted: 'documentDeleted'
}

export default {
  experienceBaseRoute,
  singleConfigBaseRoute,
  requirementsBaseRoute,
  nuxtBaseUrl,
  eventOptions,
}
